// Subcategory grid carousel JS
/* eslint-disable */
/* @ts-nocheck */

document.addEventListener("DOMContentLoaded", function() {
  // Find all subcategory grids
  const grids = document.querySelectorAll(".vv-subcategory-grid");
  
  // Loop through each grid
  for (let i = 0; i < grids.length; i++) {
    const grid = grids[i];
    if (grid) {
      setupGrid(grid);
    }
  }
  
  /**
   * Setup a single grid
   * @param {Element} gridElement - The grid element to setup
   */
  function setupGrid(gridElement) {
    if (!gridElement) return;
    
    const grid = gridElement;
    const container = grid.querySelector(".vv-subcategory-grid__container");
    if (!container) return;
    
    /**
     * Setup text-only cards
     */
    function setupTextOnlyCards() {
      const textCards = grid.querySelectorAll(".vv-subcategory-card__inner.no-image");
      if (textCards.length === 0) return;
      
      const height = window.innerWidth <= 768 ? "50px" : "60px";
      
      for (let i = 0; i < textCards.length; i++) {
        const card = textCards[i];
        if (card && card instanceof HTMLElement) {
          card.style.height = height;
          card.style.minHeight = height;
          
          const content = card.querySelector(".vv-subcategory-card__content");
          if (content && content instanceof HTMLElement) {
            content.style.justifyContent = "center";
            content.style.alignItems = "center";
            content.style.textAlign = "center";
          }
        }
      }
    }
    
    /**
     * Fix image fitting
     */
    function fixImages() {
      const imgContainers = grid.querySelectorAll(".vv-subcategory-card__image-container");
      
      for (let i = 0; i < imgContainers.length; i++) {
        const imgContainer = imgContainers[i];
        if (imgContainer && imgContainer instanceof HTMLElement) {
          const img = imgContainer.querySelector("img");
          
          if (img && img instanceof HTMLElement) {
            img.style.display = "block";
            img.style.maxHeight = imgContainer.offsetHeight + "px";
            
            if (imgContainer.parentNode) {
              const parent = imgContainer.parentNode;
              if (parent instanceof HTMLElement) {
                const position = parent.getAttribute("data-title-position");
                if (position === "left_of_image" || position === "right_of_image") {
                  const width = getComputedStyle(grid).getPropertyValue("--vv-side-image-width");
                  if (width) {
                    imgContainer.style.width = width;
                  }
                }
              }
            }
          }
        }
      }
    }
    
    /**
     * Layout for different screen sizes
     */
    function optimizeLayout() {
      const width = window.innerWidth;
      
      // Mobile vs Desktop specific logic that CSS can't handle
      if (width < 768) {
        // Make sure the gradient is visible on mobile
        if (!grid.classList.contains("has-gradient")) {
          grid.classList.add("has-gradient");
        }
      }
      // Desktop
      else {
        // Remove gradient on desktop
        grid.classList.remove("has-gradient");
      }
      
      // Run functions that might depend on layout changes
      fixImages();
    }
    
    // Initial setup
    optimizeLayout();
    setupTextOnlyCards();
    
    // Add resize event listener with debounce for better performance
    let resizeTimer;
    window.addEventListener("resize", function() {
      if (resizeTimer) {
        clearTimeout(resizeTimer);
      }
      resizeTimer = window.setTimeout(function() {
        optimizeLayout();
        setupTextOnlyCards();
      }, 100);
    });
  }
});
